import styled from 'styled-components'
import { Col, Row } from 'antd'

export const CandidateListWrapper = styled.div`
  padding: 12px;
  border-radius: 8px;
`

export const SpaceBetweenRow = styled(Row)`
  align-items: flex-end;
  margin-bottom: 16px;
`

export const StyledFilterCol = styled(Col)``

export const FilterLabel = styled.label`
  font-weight: 500;
  color: #4b5563;
  display: block;
  margin-bottom: 4px;
  font-size: 14px;
`

export const StyledFormItem = styled.div`
  .ant-select {
    width: 100%;
  }
`

export const HeaderFullWidth = styled.div`
  width: 100%;
`

export const MultiPadding = styled.div`
  padding: 16px 0;
  display: flex;
  gap: 16px;
  align-items: center;
`

export const BoldText = styled.span`
  font-weight: 600;
  white-space: nowrap;
`

export const FilterMenuWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
  width: 280px;
`

export const FilterFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  border-top: 1px solid #f0f0f0;
  padding-top: 12px;
  margin-top: 4px;
`

export const CandidateInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`

// Wrapper that allows horizontal scrolling but hides the scrollbar UI
export const NoScrollbarX = styled.div`
  max-width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */

  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Opera */
  }
`

export const CandidateName = styled.span`
  font-weight: 600;
  color: #3249d7;
  display: block;
  cursor: pointer;
  word-break: break-word;
  &:hover {
    text-decoration: underline;
  }
`

export const CandidateId = styled.span`
  font-size: 12px;
  color: #6b7280;
  word-break: break-word;
`

export const ContactInfo = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 14px;
  color: #374151;
  word-break: break-word;
`

export const CefrLevel = styled.div`
  display: flex;
  align-items: baseline;
  gap: 8px;
  justify-content: center;
`

export const PrimaryCefr = styled.span`
  font-weight: 700;
  font-size: 16px;
  color: #1f2937;
`

export const SecondaryCefr = styled.span`
  color: #6b7280;
  font-size: 14px;
  text-decoration: line-through;
`

export const NoData = styled.div`
  text-align: center;
  padding: 40px;
  color: #6b7280;
`

// Level Badges - matching DiagnosisList
export const LevelBadge = styled.span`
  display: inline-block;
  padding: 4px 12px;
  border-radius: 16px;
  font-weight: 600;
  font-size: 13px;
  background: ${props => {
    const level = props.level?.toUpperCase()
    if (['C2-ADVANCED', 'C1-ADVANCED', 'ADVANCED'].includes(level)) return '#dcfce7'
    if (['B2-UPPER-INTERMEDIATE', 'B1-INTERMEDIATE', 'COMPETENT', 'INTERMEDIATE'].includes(level)) return '#dbeafe'
    if (['A2-BEGINNER', 'A1-BEGINNER', 'LEARNER', 'BEGINNER'].includes(level)) return '#fef3c7'
    return '#f3f4f6'
  }};
  color: ${props => {
    const level = props.level?.toUpperCase()
    if (['C2-ADVANCED', 'C1-ADVANCED', 'ADVANCED'].includes(level)) return '#166534'
    if (['B2-UPPER-INTERMEDIATE', 'B1-INTERMEDIATE', 'COMPETENT', 'INTERMEDIATE'].includes(level)) return '#1d4ed8'
    if (['A2-BEGINNER', 'A1-BEGINNER', 'LEARNER', 'BEGINNER'].includes(level)) return '#92400e'
    return '#374151'
  }};
`